export const getAuthToken = () =>{
  const token = localStorage.getItem('MSAL_TOKEN');
  const Authorization = "Bearer " + token;
  return Authorization; 
}